/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MainContextSection } from './MainContextSection';
import {
    MainContextSectionFromJSON,
    MainContextSectionFromJSONTyped,
    MainContextSectionToJSON,
} from './MainContextSection';
import type { TenantMainContext } from './TenantMainContext';
import {
    TenantMainContextFromJSON,
    TenantMainContextFromJSONTyped,
    TenantMainContextToJSON,
} from './TenantMainContext';

/**
 * 
 * @export
 * @interface TenantMainContextResponse
 */
export interface TenantMainContextResponse {
    /**
     * 
     * @type {TenantMainContext}
     * @memberof TenantMainContextResponse
     */
    record?: TenantMainContext;
    /**
     * The code-default section catalog converted to sections (first-time seeding / reset-to-template).
     * @type {Array<MainContextSection>}
     * @memberof TenantMainContextResponse
     */
    template_sections?: Array<MainContextSection>;
}

/**
 * Check if a given object implements the TenantMainContextResponse interface.
 */
export function instanceOfTenantMainContextResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantMainContextResponseFromJSON(json: any): TenantMainContextResponse {
    return TenantMainContextResponseFromJSONTyped(json, false);
}

export function TenantMainContextResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantMainContextResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'record': !exists(json, 'record') ? undefined : TenantMainContextFromJSON(json['record']),
        'template_sections': !exists(json, 'template_sections') ? undefined : ((json['template_sections'] as Array<any>).map(MainContextSectionFromJSON)),
    };
}

export function TenantMainContextResponseToJSON(value?: TenantMainContextResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'record': TenantMainContextToJSON(value.record),
        'template_sections': value.template_sections === undefined ? undefined : ((value.template_sections as Array<any>).map(MainContextSectionToJSON)),
    };
}

